import type { ComponentProps } from 'react';

import { cn } from '../cn';

/**
 * The straight arrow, on a 24 by 24 box shared with PopupIcon: a 16-unit shaft
 * with 8.5-unit head legs, stroke 3. The shaft is short for the head on
 * purpose: at button size a longer one read as a line with a small tip. The
 * two icons are drawn to the same numbers
 * so one size class puts them beside each other at the same length and
 * weight; size them with `size-*`, never by width alone.
 *
 * Copied from ui/icons and redrawn square. The stroke is 3 where the original
 * is 2: the viewBox scales it down with the icon, so 2 rendered thinner than
 * the semibold type beside it.
 */
export const ArrowIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    className={cn('size-5', className)}
    {...props}>
    <path
      d='M4 12H20M20 12L14 6M20 12L14 18'
      stroke='currentColor'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
